module.exports = __webpack_public_path__ + "static/img/12002B_1_2_R_20210809_LC.7400ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12002B_1_2_R_20210809_LC.png
// module id = p5eu
// module chunks = 0